import { getReqHeaderParams } from './utils';
interface Params {
  url: string;
  method: string;
  data: any;
  params: any;
  dataType: string;
  headers?: {
    [key: string]: any;
  };
}
const request = (method: 'POST' | 'GET') => <T>(options: any): Promise<[null, T] | [any]> => {
  const Network = Mach.requireModule('Network');
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve) => {
    const { url, data = null, headers = null } = options;
    const headerParams = await getReqHeaderParams();
    const params: Params = {
      url,
      method,
      data: null,
      params: null,
      dataType: 'json',
      headers: {
        ...headerParams,
        ...headers,
      },
    };
    if (method === 'GET') {
      params.params = data;
    } else {
      params.data = data;
    }

    Network.request(params, (result, err) => {
      const { data } = result;
      if (!err) {
        const {
          message = '', data: rawData, code, error
        } = data || {};
        if ([0, 200].includes(code)) {
          resolve([null, rawData]);
        } else {
          resolve([{ message, code, error }]);
        }
        return;
      }
      resolve([{ message: 'request fail', code: -1, err }]);
    });
  });
};

const $post = request('POST');
const $get = request('GET');
export { $post, $get };
